<template>
    <header
        v-if="route.meta.layout !== 'account'"
        :class="{
            'bg-christmas-gradient': christmas,
        }"
    >
        <div class="flex flex-col lg:flex-row justify-between py-7 px-6 lg:px-5">
            <div class="hidden lg:flex flex-col justify-center items-center lg:w-48">
                <a
                    v-if="route.path !== '/'"
                    class="no-underline lg:w-48 flex items-start cursor-pointer lg:mb-0"
                    @click="goHome"
                >
                    <icon-arrow-left
                        class="h-5 w-auto mr-5"
                        filled
                    />
                    {{ $t("layouts.header.back") }}
                </a>
            </div>
            <img
                alt="Store Logos"
                class="w-full h-auto max-h-20"
                src="/images/logos/stores.svg"
            />
            <!-- Empty div to keep the layout consistent -->
            <div class="hidden lg:w-48 lg:block" />
        </div>
    </header>
    <div
        v-else
        class="lg:hidden"
    >
        <account-sidebar-toggle />
    </div>
</template>

<script lang="ts" setup>
import type { KadeweUser } from "~/types";
import IconArrowLeft from "~/public/icons/arrow_left.svg";

defineProps<{
    whiteLogo?: boolean;
}>();

const localePath = useLocalePath();
const route = useRoute();
const user = useSanctumUser<KadeweUser>();
const { isAuthenticated, logout } = useSanctumAuth();

const goHome = async () => {
    if (route.meta.layout === "cms") {
        await navigateTo(localePath("/portal/card"));
        return;
    }

    if (isAuthenticated.value) {
        await logout();
    }

    await navigateTo(localePath("/"));
};

const christmas = computed(() => {
    return user?.value?.special_events?.christmas && route.path.startsWith(localePath("/portal"));
});
</script>

<style scoped>
.bg-christmas-gradient {
    background: linear-gradient(180deg, #987d52 -315%, #ebdcb0 -70%, #987d52 296%);
}
</style>
